
var React =     require("react");
var Utilities = require("../../util/Utilities.js");

// TODO should also come from a generic TwoButtonSwitch,
// and impliment props with the images
class GridLayoutSwitch extends React.Component {

    constructor(){
        super();

        this.toggleGridView = this.toggleGridView.bind(this);
        this.toggleListView = this.toggleListView.bind(this);
    }

    toggleGridView() {
        this.setState({ layout: "grid" });
        googleGA("send", "event", Utilities.getPath(), "toggleGridView");
        if (this.props.onGridLayoutSwitchChanged) {
            this.props.onGridLayoutSwitchChanged("grid");
        }
    }
    
    toggleListView() {
        this.setState({ layout: "list" });
        googleGA("send", "event", Utilities.getPath(), "toggleListView");
        if (this.props.onGridLayoutSwitchChanged) {
            this.props.onGridLayoutSwitchChanged("list");
        }
    }

    render() {
        this.style = this.state ? this.state.layout : this.props.layoutStyle;
        return (
            <div className={"layout-switch -" + this.style}>
                <svg width="25" height="17" xmlns="http://www.w3.org/2000/svg" className="layout-switch__grid" onClick={this.toggleGridView}>
                    <use xlinkHref='#switch__grid' />
                </svg>
                <svg width="24" height="17" xmlns="http://www.w3.org/2000/svg" className="layout-switch__list" onClick={this.toggleListView}>
                    <use xlinkHref='#switch__list' />
                </svg>
            </div>
        );
    }
}

module.exports = GridLayoutSwitch;
